import Vue from "vue";
// Import styles
import "ant-design-vue/lib/alert/style/css";
import "ant-design-vue/lib/avatar/style/css";
import "ant-design-vue/lib/badge/style/css";
import "ant-design-vue/lib/button/style/css";
import "ant-design-vue/lib/card/style/css";
import "ant-design-vue/lib/checkbox/style/css";
import "ant-design-vue/lib/collapse/style/css";
import "ant-design-vue/lib/date-picker/style/css";
import "ant-design-vue/lib/descriptions/style/css";
import "ant-design-vue/lib/divider/style/css";
import "ant-design-vue/lib/drawer/style/css";
import "ant-design-vue/lib/dropdown/style/css";
import "ant-design-vue/lib/empty/style/css";
import "ant-design-vue/lib/form-model/style/css";
import "ant-design-vue/lib/form/style/css";
import "ant-design-vue/lib/grid/style/css";
import "ant-design-vue/lib/icon/style/css";
import "ant-design-vue/lib/input-number/style/css";
import "ant-design-vue/lib/input/style/css";
import "ant-design-vue/lib/list/style/css";
import "ant-design-vue/lib/menu/style/css";
import "ant-design-vue/lib/message/style/css";
import "ant-design-vue/lib/modal/style/css";
import "ant-design-vue/lib/notification/style/css";
import "ant-design-vue/lib/popconfirm/style/css";
import "ant-design-vue/lib/popover/style/css";
import "ant-design-vue/lib/progress/style/css";
import "ant-design-vue/lib/pagination/style/css";
import "ant-design-vue/lib/radio/style/css";
import "ant-design-vue/lib/select/style/css";
import "ant-design-vue/lib/skeleton/style/css";
import "ant-design-vue/lib/space/style/css";
import "ant-design-vue/lib/spin/style/css";
import "ant-design-vue/lib/steps/style/css";
import "ant-design-vue/lib/switch/style/css";
import "ant-design-vue/lib/tabs/style/css";
import "ant-design-vue/lib/tag/style/css";
import "ant-design-vue/lib/table/style/css";
import "ant-design-vue/lib/time-picker/style/css";
import "ant-design-vue/lib/timeline/style/css";
import "ant-design-vue/lib/tooltip/style/css";
import "ant-design-vue/lib/tree-select/style/css";
import "ant-design-vue/lib/upload/style/css";
import "./ant-custom-css";
// Get component
import {
  Alert,
  AutoComplete,
  Avatar,
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Drawer,
  Divider,
  Dropdown,
  Descriptions,
  Empty,
  Form,
  FormModel,
  Icon,
  Input,
  InputNumber,
  List,
  Menu,
  message,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Timeline,
  TimePicker,
  Tooltip,
  TreeSelect,
  Upload,
} from "ant-design-vue";

// Prototype settings
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;

// Register to vue
Vue.use(Alert);
Vue.use(Alert);
Vue.use(AutoComplete);
Vue.use(Avatar);
Vue.use(Badge);
Vue.use(Button);
Vue.use(Card);
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(DatePicker);
Vue.use(Descriptions);
Vue.use(Divider);
Vue.use(Drawer);
Vue.use(Dropdown);
Vue.use(Empty);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(List);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(Row);
Vue.use(Select);
Vue.use(Skeleton);
Vue.use(Space);
Vue.use(Spin);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Tabs);
Vue.use(Table);
Vue.use(Tag);
Vue.use(TimePicker);
Vue.use(Timeline);
Vue.use(Tooltip);
Vue.use(TreeSelect);
Vue.use(Upload);
Vue.use(message);
Vue.use(notification);
